import webLog from '../util/webLog';
import { isHCIOSApp, isHCAndroidApp, isHCApp } from '../util/util';
import '../util/disableME';

class HCApp {
  constructor() {
    if(/hengchi\w+(\d+\.\d+\.\d+)/.test(navigator.userAgent)) {
      this.AppVersion = RegExp.$1
    }

    // 初始化事件，App通过document.dispatchEvent 方法派发事件
    this.events = {};
    ['onHCPagePause','onHCPageResume'].forEach(eventName => {
      const event = document.createEvent('Event')
      event.initEvent(eventName, true, true)
      window[eventName] = () => {
        document.dispatchEvent(event);
      }
    })

    // 隐藏loading
    this.postMessage({
      methodName: 'hideLoading'
    })

    // web日志上报工具
    this.log = webLog
  }
  /**
   * @param {string} methodName 方法名称，必传
   * @param {object} params 参数，必传
   */
  postMessage(params) {
    // 验证参数合法性
    if (!params.methodName) {
      console.error('无 methodName 参数');
      return
    }
    // 自有封装方法 - 确认登录
    if(params.methodName === 'confirmLogin') {
      return this.confirmLogin()
    }
    return new Promise((resolve) => {
      if(!params.params) {
        params.params = {}
      }

      // 生成唯一回调id
      const callbackId = `${params.methodName}CallBack${Date.now()}`;
      params.callback = callbackId;
      // 客户端回调函数，必须要挂在全局变量下才能回调到
      window[callbackId] = (data) => {
        console.log(`-------- result: ${params.methodName} --------`);
        console.log(data);
        resolve(data);
        window[callbackId] = null;
      };

      // h5自己的返回按钮不会触发registerBackHook事件，固种一个标志，在调用goBack时，先执行下registerBackHook的回调。
      if(params.methodName === 'registerBackHook') {
        this.registerBackHookFlag = 1
        this.registerBackHookCallBack = callbackId
      }
      
      // 由于安卓手势返回会触发registerBackHook的回调，业务代码中进而会调用goBack，这时不应该拦截，所以加了immediate用以区分
      if(params.methodName === 'goBack' && this.registerBackHookFlag && !params.immediate) {
        this.registerBackHookFlag = undefined
        console.log(`-------- h5端直接触发goBack回调 --------`);
        window[this.registerBackHookCallBack]({})
        return
      }

      // 不同平台，调用不同方法
      if (window.webkit?.messageHandlers?.HCwebviewBridge) {
        window.webkit.messageHandlers.HCwebviewBridge.postMessage(params);
      } else if (window.HCwebviewBridge) {
        window.HCwebviewBridge.postMessage(JSON.stringify(params));
      } else {
        resolve({ code: -1 });
        console.info(window[callbackId]({ message: '非恒驰App环境' }));
      }
    });
  }
  /** 判断有没有登陆，如果登陆则立即执行回调，否则跳转登陆台，并等到登陆完成之后执行回调 */
  confirmLogin() {
    return new Promise(async resolve => {
      let userInfo
      userInfo = await this.postMessage({ methodName: 'getUserInfo' })
      if(userInfo.nickName || userInfo.acpToken) {
        resolve(userInfo)
        return
      }
      userInfo = await this.postMessage({ methodName: 'login' })
      resolve(userInfo)
    })
  }
  /** 判断是否恒驰IOS App环境 */
  isHCIOSApp() {
    return isHCIOSApp();
  }

  /** 判断是否恒驰Android App环境 */
  isHCAndroidApp() {
    return isHCAndroidApp();
  }

  /** 判断是否恒驰App环境 */
  isHCApp() {
    return isHCApp();
  }

  /** 判断当前版本是否大于v  */
  isGreaterThan(v) {
    if(!v) {
      console.log('请传入可比较的版本号(三段式)');
      return
    }
    if(!this.isHCApp()) {
      console.log('非App环境，不能比较版本号');
      return
    }
    try {
      const versionsNums = v.split('.').map(item => Number(item))
      const AppVersionsNums = this.AppVersion.split('.').map(item => Number(item))
      for (let index = 0; index < versionsNums.length; index++) {
        if (AppVersionsNums[index] < versionsNums[index]) {
          return false
        } else if(AppVersionsNums[index] > versionsNums[index]) {
          return true
        }
      }
      return false
    } catch (error) {
      console.error('版本号比较出错', error);
    }
  }

  /** 是否小于某个版本 */
  isLessThan(v) {
    if(this.isHCApp()) {
      return !this.isGreaterThan(v) && !this.isEqual(v)
    } else {
      return false
    }
  }

  /** 是否等于某个版本 */
  isEqual(v) {
    if(this.isHCApp()) {
      return v === this.AppVersion
    } else {
      return false
    }
  }

  /** 获取App版本 */
  getAppVersion() {
    return this.AppVersion
  }

  /** 设置App版本 */
  setAppVersion(v) {
    this.AppVersion = v
  }
}

export default new HCApp();
